import React from "react";
import { CheckCircleFilled } from "@ant-design/icons";

const CompletionStep = ({
  groupName,
  joinSVG,
  backgroundColor,
  handleNext,
}) => {
  const registrationUrl = `https://group.chant.fan/${groupName
    .replace(/ /g, "")
    .replace("#", "%23")
    .toLowerCase()}/join`;

  return (
    <div className="reg-completion">
      <div className="reg-completion-icon">
        <CheckCircleFilled />
      </div>

      <h3 className="reg-completion-title">Registration is Live</h3>
      <p className="reg-completion-subtitle">
        Your membership package is now live and ready to accept registrations.
      </p>

      <div className="reg-completion-link">
        <a href={registrationUrl} target="_blank" rel="noopener noreferrer">
          {registrationUrl}
        </a>
      </div>

      {joinSVG && (
        <div className="reg-completion-qr">
          <span dangerouslySetInnerHTML={{ __html: joinSVG }} />
        </div>
      )}

      <button
        className="reg-btn reg-btn-next"
        type="button"
        style={{ backgroundColor: backgroundColor || "#1890ff" }}
        onClick={() => handleNext("previewStep", "basicsStep")}
      >
        Back to Setup
      </button>
    </div>
  );
};

export default CompletionStep;
